import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom/dist";
import { toast } from "react-toastify";

const ProtectedRoute = ({ file }) => {
  const isLogin = useSelector((state) => state?.authReducer?.isLogin);
  if (!isLogin) {
    return <Navigate to="/login" replace />;
  } else {
    return file;
  }
};

export default ProtectedRoute;
